// #region Imports
import { defineComponent } from "vue";
import { DxFileUploader } from "devextreme-vue/file-uploader";
// #endregion
// #region Core
export default defineComponent({
    // #region Vars
    name: 'g-product-selector-row',
    components: {
        DxFileUploader
    },
    // #endregion
    // #region Properties
    props: {
        selector: {
            type: Object,
            required: false,
            default: {}
        },
        selectorOption: {
            type: Object,
            required: false,
            default: {}
        },
        entryData: {
            type: Object,
            required: false,
            default: {}
        },
    },
    data: () => ({}),
    // #endregion
    // #region Watch
    watch: {
        'entryData.files': function (value) {
            if (!value || value.length == 0) {
                this.ResetFiles();
            }
        },
    },
    // #endregion
    // #region Core
    methods: {
        onUploadedFile(e) {
            this.entryData.files.push({
                fileID: e.request.getResponseHeader("X-File-Guid"),
                fileName: e.request.getResponseHeader("X-File-Name"),
            });
        },
        ResetFiles() {
            if (this.$refs.fileUploader) {
                try {
                    this.$refs.fileUploader.instance.reset();
                }
                catch (e) {
                    //Do nothing
                }
            }
        },
    },
    // #endregion
});
// #endregion
